import { gql } from 'apollo-boost'

const ADVANCED_PROBE_CRAWLING_SESSION_MENUS = gql`
  query advancedProbeCrawlingSessionMenus(
    $sessionId: ID!
    $page: Int
    $pageSize: Int
  ) {
    advancedProbeCrawlingSessionMenus(
      advancedProbeCrawlingSessionId: $sessionId
      page: $page
      pageSize: $pageSize
    ) {
      advancedProbeCrawlingSessionMenus {
        menuId
        menuStatus
        crawlingJobStatus
        crawlingStatus
        crawlingJobScheduleDate
        crawlingJobCompletedDate
        crawlingDetectedChanges
        previouslySelectedFileExists
        scrapingJobStatus
        scrapingStatus
        scrapingJobScheduleDate
        scrapingJobCompletedDate
      }
      total
    }
  }
`

export default ADVANCED_PROBE_CRAWLING_SESSION_MENUS
